/**
 * Transformations – Before & After slider. Uses theme's MinimogLibs.Swiper.
 * One slide per view; optional navigation and pagination.
 */
if (!customElements.get("m-transformations")) {
  class MTransformations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";

      if (!this.enableSlider) return;

      this.slideContainer = this.querySelector(".m-transformations__inner");
      this.trackEl = this.querySelector(".m-transformations__track");
      if (!this.slideContainer || !this.trackEl) return;

      if (typeof MinimogLibs === "undefined" || !MinimogLibs.Swiper) {
        this.initWhenReady();
        return;
      }
      this.initSlider();
    }

    initWhenReady() {
      const check = () => {
        if (typeof MinimogLibs !== "undefined" && MinimogLibs.Swiper) {
          this.initSlider();
          return true;
        }
        return false;
      };
      if (check()) return;
      const t = setInterval(() => {
        if (check()) clearInterval(t);
      }, 50);
      setTimeout(() => clearInterval(t), 5000);
    }

    initSlider() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideCount = this.trackEl ? this.trackEl.children.length : 0;
      const loop = slideCount > 1;

      this.swiper = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: loop,
        threshold: 5,
        simulateTouch: true,
        allowTouchMove: true,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        on: {
          init: () => {
            if (controlsContainer && slideCount > 1) {
              controlsContainer.classList.remove("m:hidden");
            }
          },
        },
      });

      if (this.showNavigation && prevButton && nextButton) {
        prevButton.addEventListener("click", () => this.swiper.slidePrev());
        nextButton.addEventListener("click", () => this.swiper.slideNext());
      }
    }
  }
  customElements.define("m-transformations", MTransformations);
}
